export default "__VITE_ASSET__ZLuDgZk$__"